class ColorSet extends Set {
  add(value) {
    super.add(value);
    if (this.size === 8) {
      this.clear();
    }

    return this;
  }
}

const skipCardColors = new ColorSet();
const skipThinColors = new ColorSet();
const skipClassicColors = new ColorSet();

function setRecommendations() {
  let basicProducts = document.querySelector(
    '#all-basic-products[type="application/json"]'
  );
  let lineItem1 = document.querySelector(
    '#cart-item-1[type="application/json"]'
  );
  let lineItem2 = document.querySelector(
    '#cart-item-2[type="application/json"]'
  );

  const drawerSlots = document.querySelectorAll(
    "cart-drawer .drawer__recommendations .cart-item"
  );
  const cartPageSlots = document.querySelectorAll(
    "cart-items .drawer__recommendations .cart-item"
  );

  // Ordered by most sold
  const cardColorRanking = [
    "black",
    "blue",
    "green",
    "purple",
    "red",
    "white",
    "yellow",
    "mint",
  ];
  const thinColorRanking = [
    "black",
    "blue",
    "white",
    "purple",
    "green",
    "red",
    "mint",
    "yellow",
  ];
  const classicColorRanking = [
    "black",
    "blue",
    "purple",
    "green",
    "white",
    "red",
    "mint",
    "yellow",
  ];

  const productRanking = [
    { color: "black", type: "card" },
    { color: "black", type: "thin" },
    { color: "blue", type: "card" },
    { color: "green", type: "card" },
    { color: "purple", type: "card" },
    { color: "red", type: "card" },
    { color: "white", type: "card" },
    { color: "yellow", type: "card" },
    { color: "mint", type: "card" },
    { color: "blue", type: "thin" },
    { color: "white", type: "thin" },
    { color: "black", type: "classic" },
    { color: "purple", type: "thin" },
    { color: "green", type: "thin" },
    { color: "red", type: "thin" },
    { color: "mint", type: "thin" },
    { color: "blue", type: "classic" },
    { color: "yellow", type: "thin" },
    { color: "purple", type: "classic" },
    { color: "green", type: "classic" },
    { color: "white", type: "classic" },
    { color: "red", type: "classic" },
    { color: "mint", type: "classic" },
    { color: "yellow", type: "classic" },
  ];

  let dotCardVariants;
  let dotThinVariants;
  let dotClassicVariants;

  // Get all product variants for each type
  if (basicProducts) {
    basicProducts = JSON.parse(basicProducts.textContent);
    dotCardVariants = basicProducts.find(
      (product) => product.title.toLowerCase() === "dot.card"
    ).variants;
    dotThinVariants = basicProducts.find(
      (product) => product.title.toLowerCase() === "dot.thin"
    ).variants;
    dotClassicVariants = basicProducts.find(
      (product) => product.title.toLowerCase() === "dot.classic"
    ).variants;
  }

  if (lineItem1) {
    lineItem1 = JSON.parse(lineItem1.textContent);
  }

  const itemIsBasic = (item) => {
    const productType = item?.product_type.toLowerCase();
    return (
      productType.includes("card") ||
      productType.includes("thin") ||
      productType.includes("classic")
    );
  };

  const getItemRanking = (item) =>
    productRanking.findIndex(
      ({ color, type }) =>
        color === item.variant_options[0].toLowerCase() &&
        type === item.product_type.toLowerCase()
    );

  const getItemVariant = (variants, item, skipColors = []) =>
    variants.find(
      (variant) =>
        variant.option1.toLowerCase() ===
          item.variant_options[0].toLowerCase() &&
        variant.option2.toLowerCase() === "single"
    );

  const getColorRanking = (rankingType, variant) =>
    rankingType.findIndex((color) => color === variant.option1.toLowerCase());

  const setSlot = (slot, product, type, handle) => {
    slot.querySelector(".cart-item__image").src = product.featured_image.src;
    slot.querySelector(".cart-item__variant").textContent =
      product.option1.toLowerCase();
    slot.querySelector("a").href = `/products/${handle}?variant=${product.id}`;
    slot
      .querySelector(".add-to-cart-small")
      .setAttribute("data-product-id", product.id);
    slot.querySelector(`.dot-${type}-title-svg`).style.display = "";
  };

  if (lineItem1 && itemIsBasic(lineItem1)) {
    let lineItem1Rank;
    let lineItem2Rank;
    if (lineItem2) {
      lineItem2 = JSON.parse(lineItem2.textContent);
      if (itemIsBasic(lineItem2)) lineItem2Rank = getItemRanking(lineItem2);
    }

    lineItem1Rank = getItemRanking(lineItem1);

    let mostPopularLineItem =
      lineItem1Rank < lineItem2Rank || lineItem2Rank === undefined
        ? lineItem1
        : lineItem2;

    const mostPopularItemType = mostPopularLineItem.product_type.toLowerCase();

    let { handle } = mostPopularLineItem;

    const getNextPopularVariant = (
      productVariants,
      productColorRanking,
      skipColors
    ) => {
      const nextPopularColor = productColorRanking.find((color) =>
        Array.from(skipColors).every((skipColor) => skipColor !== color)
      );
      const nextPopularVariant = productVariants.find(
        (variant) =>
          variant.option1.toLowerCase() === nextPopularColor &&
          variant.option2.toLowerCase() === "single"
      );
      return nextPopularVariant;
    };

    let thinVariant, variant, nextPopularVariant;

    // Find next popular color for the most popular type
    if (mostPopularItemType === "card") {
      variant = getNextPopularVariant(
        dotCardVariants,
        cardColorRanking,
        skipCardColors
      );
      thinVariant = getNextPopularVariant(
        dotThinVariants,
        cardColorRanking,
        skipCardColors
      );
      skipCardColors.add(variant.option1.toLowerCase());

      nextPopularVariant = getNextPopularVariant(
        dotCardVariants,
        cardColorRanking,
        skipCardColors
      );
      skipCardColors.add(nextPopularVariant.option1.toLowerCase());
    } else if (mostPopularItemType === "thin") {
      variant = getNextPopularVariant(
        dotThinVariants,
        thinColorRanking,
        skipThinColors
      );
      skipThinColors.add(variant.option1.toLowerCase());

      nextPopularVariant = getNextPopularVariant(
        dotThinVariants,
        thinColorRanking,
        skipThinColors
      );
      skipThinColors.add(nextPopularVariant.option1.toLowerCase());
      thinVariant = getNextPopularVariant(
        dotThinVariants,
        thinColorRanking,
        skipThinColors
      );
      skipThinColors.add(thinVariant.option1.toLowerCase());
    } else if (mostPopularItemType === "classic") {
      variant = getNextPopularVariant(
        dotClassicVariants,
        classicColorRanking,
        skipClassicColors
      );
      thinVariant = getNextPopularVariant(
        dotThinVariants,
        classicColorRanking,
        skipClassicColors
      );
      skipClassicColors.add(variant.option1.toLowerCase());

      nextPopularVariant = getNextPopularVariant(
        dotClassicVariants,
        classicColorRanking,
        skipClassicColors
      );
      skipClassicColors.add(nextPopularVariant.option1.toLowerCase());
    }

    if (drawerSlots.length === 3) {
      setSlot(drawerSlots[0], variant, mostPopularItemType, handle);
      setSlot(drawerSlots[1], thinVariant, "thin", "dot-thin-1");
      setSlot(drawerSlots[2], nextPopularVariant, mostPopularItemType, handle);
    }

    if (cartPageSlots.length === 3) {
      setSlot(cartPageSlots[0], variant, mostPopularItemType, handle);
      setSlot(cartPageSlots[1], thinVariant, "thin", "dot-thin-1");
      setSlot(
        cartPageSlots[2],
        nextPopularVariant,
        mostPopularItemType,
        handle
      );
    }
  }
}

function moreSuggestions() {
  setRecommendations();
}

function setInitialRecommendations() {
  skipCardColors.clear();
  skipThinColors.clear();
  skipClassicColors.clear();
  setRecommendations();
}

setInitialRecommendations();
